import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import DefaultContainer from '../../../components/DefaultContainer/DefaultContainer';
import { getClub } from '../../../service/clubs';
import { getClubForum } from '../../../service/forum';

import { CreateForum } from './CreateForum/CreateForum';

import { useUserStore } from '../../../store/useUser';
import { main_color } from '../../../styles/_variables';

import styles from './ClubForum.module.scss';
import useHeader from '../../../hooks/useHeader';
import { TopicsList } from '../../common/ClubForum/TopicsList/TopicsList';
import { CreateTopic } from '../../common/ClubForum/CreateTopic/CreateTopic';
import Icon from '../../../components/Icon/Icon';
import { getClubUser } from '../../../service/clubUser';


const ClubForum: React.FC = () => {
  const navigate = useNavigate();

  const { id, name: clubName } = useParams();

  const clubId = Number(id);
  const userId = useUserStore(state => state.id);

  const { data:clubUser, isFetching: isFetchingClubUser } = useQuery(
    ['clubUser', clubId],
    () => getClubUser(userId, clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const { data:forum, refetch, isFetching: isFetchingClubForum } = useQuery(
    ['forum', 'club', clubId],
    () => getClubForum(clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const { data:club, isFetching: isFetchingClub } = useQuery(
    ['club', clubId],
    () => getClub(clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  useHeader({ header: clubName, subheader: 'Fórum' });

  const isMember = clubUser?.wasAccepted === 1;
  const isAdminOrMediator = Boolean(clubUser?.isCreator === 1 || clubUser?.isMediator === 1);

  const isFetching = isFetchingClubForum || isFetchingClub || isFetchingClubUser;

  if (isFetching) return null;
  if (!userId) return <DefaultContainer>Você precisa fazer login</DefaultContainer>;
  if(!(isMember)) return <DefaultContainer>Você não tem permissão pra vê essa página</DefaultContainer>;

  return (
    <div>
      <div className={styles.header}>
        <div className={styles.clubHeader}
          onClick={() => navigate(`/club/${club.id}/${club.name}`)}
        >
          <Icon className={styles.icon} icon='group' color={main_color} />
          <span className={styles.name}>{club.name}</span>
        </div>
        {forum &&        
          <div className={styles.forumHeader}>
            <Icon className={styles.icon} icon='forum' color={main_color} />
            <span className={styles.name}>{forum.title}</span>
          </div>
        }
      </div>
      <div className={styles.clubsContainer}>
        {userId && (!forum) && (isAdminOrMediator) &&
          <CreateForum refetchData={refetch} userId={Number(userId)} clubId={Number(clubId)} ></CreateForum>
        }
        {forum && 
          <div>
            <TopicsList forumId={forum.id} clubId={clubId} isAdminOrMediator={isAdminOrMediator} userId={userId} />
            <CreateTopic forumId={forum.id} clubId={clubId} userId={userId} refetchData={refetch} />
          </div>
        }
      </div>
    </div>
  )
}

export default ClubForum;